// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"5117dda3","316":"3e88ab05","875":"87fca1bd"}[chunkId] + ".chunk.css";
};